import React from "react"
import { Translate } from "utils/i18n-shim"
import { Field } from "formik"
import { Grid } from "@mui/material"

import useLocale from "hooks/useLocale"
import { getPriceInputAdornmentProps } from "shared"
import { SubCard } from "shared/ui/berry-jass"
import { PriceInput } from "shared/ui/berry-jass-formik"
import {
  NewGradedPricingForm,
  formatSalesProduct
} from "entities/sales-product"

export const SalesProductCard = ({ data, index }) => {
  const locale = useLocale()

  return (
    <SubCard
      title={formatSalesProduct(data, locale)}
      data-testid={`sales-product-${data.id}-fields`}
    >
      <Grid container rowSpacing={3} columnSpacing={2}>
        <Grid item md={4} sm={6} xs={12}>
          <Field
            fullWidth
            name={`sales_products.${index}.new_rrp`}
            component={PriceInput}
            label={<Translate value="product.rrp.title" />}
            {...getPriceInputAdornmentProps(data.rrp)}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <Field
            fullWidth
            name={`sales_products.${index}.new_seller_lower_limit`}
            component={PriceInput}
            label={<Translate value="product.lower-limit.title" />}
            {...getPriceInputAdornmentProps(data.seller_lower_limit)}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <Field
            fullWidth
            name={`sales_products.${index}.new_tl_price`}
            component={PriceInput}
            label={<Translate value="product.tl-price.title" />}
            {...getPriceInputAdornmentProps(data.tl_price)}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <Field
            fullWidth
            name={`sales_products.${index}.new_price_in_package`}
            component={PriceInput}
            label={<Translate value="products.price-in-package.title" />}
            {...getPriceInputAdornmentProps(data.price_in_package)}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <Field
            fullWidth
            name={`sales_products.${index}.new_min_price_in_package`}
            component={PriceInput}
            label={<Translate value="products.min-price-in-package.title" />}
            {...getPriceInputAdornmentProps(data.min_price_in_package)}
          />
        </Grid>

        <Grid item md={12}>
          <NewGradedPricingForm
            salesProduct={data}
            prefix={`sales_products.${index}.product_prices`}
          />
        </Grid>
      </Grid>
    </SubCard>
  )
}
